import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=0930c4bd&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "@/common.css?vue&type=style&index=0&id=0930c4bd&scoped=true&lang=css&"
import style1 from "./Tab.vue?vue&type=style&index=1&id=0930c4bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930c4bd",
  null
  
)

export default component.exports